export const isSunsetOverdue = (sunsetDate) =>
	Boolean(sunsetDate) && new Date(sunsetDate) < new Date();
